
export const LOAD_ALL_TYPES = 'LOAD_ALL_TYPES'
export const UNLOAD_ALL_TYPES = 'UNLOAD_ALL_TYPES'

export const LOAD_CURATION_TYPES = 'LOAD_CURATION_TYPES'
export const UNLOAD_CURATION_TYPES = 'UNLOAD_CURATION_TYPES'

export const LOAD_OBJECT_TYPES = 'LOAD_OBJECT_TYPES'
export const UNLOAD_OBJECT_TYPES = 'UNLOAD_OBJECT_TYPES'

export const UPDATE_QTD_OBJECT_TYPES = 'UPDATE_QTD_OBJECT_TYPES'

export default {
	[LOAD_ALL_TYPES] (state, payload) {
		state.db = payload.data
	},
	[UNLOAD_ALL_TYPES] (state, payload) {
		state.db = payload.data
	},

	[LOAD_CURATION_TYPES] (state, payload) {
		state.curation = payload.data
	},
	[UNLOAD_CURATION_TYPES] (state, payload) {
		state.curation = payload.data
	},

	[LOAD_OBJECT_TYPES] (state, payload) {
		state.object = payload.data
	},
	[UNLOAD_OBJECT_TYPES] (state, payload) {
		state.object = payload.data
	},
	[UPDATE_QTD_OBJECT_TYPES] (state, payload) {
		state[payload.type][payload.index].qtd = payload.qtd
		state[payload.type][payload.index].dirty = payload.dirty
	}
}
